import { type TLimitedAudioLicense } from '@core/models'

type TIconSize = {
    width: number
    height: number
}

export const LICENSE_ICON_SIZES: Record<TLimitedAudioLicense, TIconSize> = {
    arr: { width: 16, height: 18 },
    'cc-0': { width: 16, height: 18 },
    'cc-by': { width: 16, height: 18 },
    'cc-by-nc': { width: 36, height: 18 },
    'cc-by-sa': { width: 36, height: 16 },
}
